import { useState, useEffect } from "react";

const CountdownTimer = ({ remainingSeconds, onTimerEnd }) => {
    // Before using remainingSeconds, convert target date to remaining seconds
    let remaining_seconds = getRemainingSeconds(remainingSeconds);
    function getRemainingSeconds(targetTime) {
        const now = Date.now();                // current time in ms
        const target = new Date(targetTime).getTime(); // target time in ms
        const diffMs = target - now;           // difference in ms
        return Math.max(0, Math.floor(diffMs / 1000));
    }


  const [timeLeft, setTimeLeft] = useState(remaining_seconds);

  useEffect(() => {
    if (timeLeft <= 0) {
      onTimerEnd();
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timer); // Cleanup on unmount
  }, [timeLeft]);

  // Convert seconds to Days, Hours, Minutes, Seconds
  const formatTime = (seconds) => {
    const days = Math.floor(seconds / (24 * 3600));
    const hours = Math.floor((seconds % (24 * 3600)) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    let timeString = "";
    if (days > 0) timeString += `${days}d `;
    if (hours > 0 || days > 0) timeString += `${hours}h `; // Show hours if days exist
    if (minutes > 0 || hours > 0 || days > 0) timeString += `${minutes}m `; // Show minutes if hours exist
    timeString += `${secs}s`; // Always show seconds

    return timeString.trim();
  };

  return formatTime(timeLeft);
};

export default CountdownTimer;
// export { CountdownTimer };